import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ApiKey } from 'src/features/apiKeys/utils/types';

const RESOURCE = 'sp-core/:parkingId/system/api-key/';

type MutationFnType = typeof mutationFn;
interface DTO {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<ApiKey> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateApiKeys };
